
import { TableHeader } from "../../commons";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../commons/ScrollToTop";
import AllExternalUserEmailerTableData from "./AllExternalUserEmailerTableData";
import { ALL_EXTERNAL_USER_EMAILER_LIST_HEADERS } from "../../../constant/tableHeadersConstants/allExternalUserEmailerConst";
import { GetAllExternalEmailerListType } from "../../../commonTypes/listing";

type AppProps = {
  fetching: boolean;
  offset: number;
  data: GetAllExternalEmailerListType[] | [];
  handleShowAllEmailerAssigned:(data:any)=>void;

};

const AllExternalUserEmailerTable = ({
  fetching,
  offset,
  data,
  handleShowAllEmailerAssigned
}: AppProps) => {
  return (
    <div className="jobsType" style={{ overflowX: "scroll"}}>
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header">
          <TableHeader tableHeader={ALL_EXTERNAL_USER_EMAILER_LIST_HEADERS} />
        </thead>
        <tbody>
          <AllExternalUserEmailerTableData
            data={data}
            tableHeader={ALL_EXTERNAL_USER_EMAILER_LIST_HEADERS}
            handleShowAllEmailerAssigned={handleShowAllEmailerAssigned}
          
          />
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default AllExternalUserEmailerTable;


